import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import AssetPlatform from './components/AssetPlatform';
import GrantWriting from './components/GrantWriting';
import Testimonials from './components/Testimonials';
import Mission from './components/Mission';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <AssetPlatform />
      <GrantWriting />
      <Testimonials />
      <Mission />
      <CTA />
      <Footer />
    </div>
  );
}
